module.exports = __webpack_public_path__ + "static/media/iPhoneX09SpaceGreyRight@2x.78785066.png";